import { Link } from 'react-router-dom'

import { AdvancedImage } from '@/components/ui/advanced-image'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { DashboardModel } from '@/types'

interface LowStockAlertsProps {
  alerts: DashboardModel.LowStockAlert[]
  className?: string
}

export const LowStockAlerts = ({ alerts, className }: LowStockAlertsProps) => {
  const items = alerts ?? []
  return (
    <Card className={className}>
      <CardHeader className="flex-row items-start justify-between gap-3 space-y-0">
        <div>
          <CardTitle className="w-fit text-sm font-semibold underline decoration-faint decoration-dotted underline-offset-4">Low stock</CardTitle>
          <CardDescription className="mt-1 text-xs">Products running out</CardDescription>
        </div>
        <Button variant="link" size="sm" asChild>
          <Link to="/inventory">Manage inventory</Link>
        </Button>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="py-4 text-center text-sm text-muted-foreground">Everything is in stock.</p>
        ) : (
          <ul className="divide-y divide-border-subtle">
            {items.map((item) => (
              <li key={item.id} className="flex items-center gap-3 py-2.5 first:pt-0 last:pb-0">
                <AdvancedImage src={item.image} alt="" className="size-10 shrink-0 rounded-md border border-border bg-subdued" fallbackText="Stk" />
                <p className="min-w-0 flex-1 truncate text-sm font-medium text-ink">{item.name}</p>
                <Badge tone={item.remaining <= 0 ? 'error' : 'warning'}>
                  {item.remaining <= 0 ? 'Out of stock' : `${item.remaining} left`}
                </Badge>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  )
}
